import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import API from '../Services/PartyMenu'
import LocationList from "./Location";


const PartyMenuList = () => {
    const [error, setError] = useState({});
    const [id, setId] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const [status, setStatus] = useState([])
    const [createdDate, setCreatedDate] = useState([])
    const [errors, setErrors] = useState({});
    const [image, setImage] = useState(null);
    const [paryMenuList, setPartyMenuList] = useState([])
    const [getLogo, setGetLogo] = useState("")
    const [centerName, setCenterName] = useState("")
    const [logoPreview, setLogoPreview] = useState(null);
    const [locationId, setLocationId] = useState("")


    useEffect(() => {
        getMenuList()
    }, [currentPage])



    const validateFields = () => {
        const errors = {};
        if (!locationId) { errors.locationId = "Center is required" }
        //  if (!image) errors.image = "Image is required";
        setErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const getMenuList = async () => {
        try {
            const response = await API.getPartyMenu('');
           // console.log('response data....', response?.data?.result);
            setPartyMenuList(response?.data?.result)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection.");
            } else if (error.response.status === 403) {
                window.location.replace("/Login");
                toast.error("Session expired. Please log in again.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };


    const handleGetData = async (id) => {
        console.log("id......", id)
        try {
            // const response = await API.getPartyMenu(id);
             const response = await API.getPartyMenu(`?id=${id}`);
            const fetchedData = response?.data?.result[0];
            console.log('fetchedData', fetchedData);
            if (fetchedData) {
                //setHighlight(true);
                setId(fetchedData.id);
                setStatus(fetchedData?.is_active)
                setCreatedDate(fetchedData?.createdAt)
                setLocationId(fetchedData?.location_id)
                setLogoPreview(fetchedData?.menu)
                setCenterName(fetchedData?.location_name)
            } else {
                toast.error("Failed to Advance details.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const updateMenuData = async () => {
        if (!validateFields()) return;
        try {
            const formData = new FormData();
            // console.log('iiii', image);

            formData.append("location_id", locationId);

            if (image && typeof image === "object" && image instanceof Blob) {
                formData.append("menu", image);
            }

            for (let pair of formData.entries()) {
                console.log(`${pair[0]}: ${pair[1]}`);
            }
            const response = await API.updateMenuData(id, formData);
            console.log('response', response);
            if (response?.status === 200) {
                toast.success(response?.data?.message);
                setTimeout(() => window.location.reload(), 2000);
                getMenuList();
            } else {
                toast.error(response?.data?.message || "Failed to update party menu. Please try again.");
            }
        } catch (error) {
            console.error("Error updating party menu:", error);

            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
            else {
                toast.error(error?.response?.data?.message || "An error occurred. Please try again.");
            }
        }
    };

    const changeStatus = async (id, currentStatus) => {
        console.log("stautus...", id, currentStatus)
        const updatedStatus = !currentStatus;
        try {
            const response = await API.UpdateMenuStatus(id, updatedStatus);
            console.log(".........", response?.data)
            if (response.status === 200) {
                setPartyMenuList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Party Menu ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getMenuList();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            handleError(error);
        }
    };


    const handleError = (error) => {
        console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const handleCancel = () => {
        setId("")
        setLocationId("")
        setImage("")
    }



    const handleGetLogo = (logo) => {
        setGetLogo(logo);
    }

    const handleLogoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedFormats = ['image/jpeg', 'application/pdf'];
            const maxSize = 5 * 1024 * 1024; // 5MB

            if (!allowedFormats.includes(file.type)) {
                toast.error("Only JPEG and PDF formats are allowed.");
                event.target.value = '';
                return;
            }

            if (file.size > maxSize) {
                toast.error("File size must be 5MB or smaller.");
                event.target.value = '';
                return;
            }

            setImage(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    return (
        <div>
            <div >
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h4 className="card-title mb-0">Added Party Menu</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered text-center">
                                    <thead>
                                        <tr>
                                            <th>SrNo</th>
                                            <th>Action</th>
                                            <th>Center Name</th>
                                            <th>Status</th>
                                            <th>Created-Date</th>
                                            <th>Image</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {paryMenuList.map((item, index) => (
                                            <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                                <td>{(currentPage - 1) * perPage + index + 1}</td>
                                                <td>
                                                    <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                        <ul className="navbar-nav navbar-nav-right">
                                                            <li className="nav-item nav-profile1">
                                                                <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <div className="nav-profile-text1">
                                                                        <p className="mb-1 text-black">
                                                                        </p>
                                                                    </div>
                                                                </span>
                                                                <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                                <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalViewDiscount">
                                                                            View
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item.id)}
                                                                            className="btn btn-primary btn-sm" type="button"
                                                                            data-bs-toggle="modal" data-bs-target="#myModal"
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">

                                                                        <button
                                                                            className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                            onClick={() => changeStatus(item.id, item.is_active)}
                                                                        >
                                                                            {item.is_active ? "De-Activate" : "Activate"}
                                                                        </button>

                                                                    </a>

                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>{item.location_name}</td>
                                                <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                                <td>
                                                    {moment(item.createdAt).format("DD-MM-YYYY")}
                                                </td>
                                                <td>
                                                    {item.menu ? (
                                                        item.menu.toLowerCase().endsWith(".pdf") ? (
                                                            // PDF → Show Download button
                                                            <a
                                                                href={item.menu}
                                                                download
                                                                className="btn btn-sm btn-success"
                                                            >
                                                                Download PDF
                                                            </a>
                                                        ) : (
                                                            <button
                                                                onClick={() => handleGetLogo(item.menu)}
                                                                className="btn btn-success btn-sm"
                                                                type="button"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#myModallogo"
                                                            >
                                                                View
                                                            </button>
                                                        )
                                                    ) : (
                                                        <span>N/A</span>
                                                    )}
                                                </td>

                                                {/* <td>
                                                    {item.menu && item.menu.trim() !== "" ? (
                                                        <button
                                                            onClick={() => handleGetLogo(item.menu)}
                                                            className="btn btn-success btn-sm"
                                                            type="button"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#myModallogo"
                                                        >
                                                            View
                                                        </button>
                                                    ) : "N/A"}

                                                </td> */}
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <section>
                        <div className="modal" id="myModallogo">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Image</h4>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row my-3" style={{ justifyContent: "center" }}>
                                            <img src={getLogo || 'No Image Available'} alt="Logo" style={{ "width": "200px", "height": "150px" }} />
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section>
                        <div className="modal" id="myModalViewDiscount">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Party Menu Details</h4>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                                    </div>
                                    <div className="modal-body">
                                        <table className="table table-bordered border-secondary">
                                            <thead>
                                                <tr>
                                                    <th>Center Name</th>
                                                    <th>Status</th>
                                                    <th>Created Date</th>
                                                </tr>
                                                <tr>
                                                    <td>{centerName}</td>
                                                    <td>{status ? "Active" : "De-Activated"}</td>
                                                    <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                                                </tr>
                                                <tr>
                                                    <th>Image</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {logoPreview ? (
                                                            /\.(pdf)$/i.test(logoPreview) ? (
                                                                <a
                                                                    href={logoPreview}
                                                                    download
                                                                    className="btn btn-sm btn-success"
                                                                >
                                                                    Download PDF
                                                                </a>
                                                            ) : (
                                                                /\.(jpg|jpeg|png)$/i.test(logoPreview) ? (
                                                                    <img
                                                                        src={logoPreview}
                                                                        alt="Image Preview"
                                                                        width="50"
                                                                        height="50"
                                                                        style={{ objectFit: "cover" }}
                                                                    />
                                                                ) : (
                                                                    <span>Unsupported file format</span>
                                                                )
                                                            )
                                                        ) : (
                                                            <span>No File Available</span>
                                                        )}
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                    <div className="modal-footer">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section>
                        <div className="modal fade" id="myModal" data-bs-backdrop="static">
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Update Party Menu</h4>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <LocationList
                                                        selectedLocation={locationId}
                                                        label="Center"
                                                        isRequired={false}
                                                        disabled={true}
                                                        setSelectedLocation={(location) => {
                                                            setLocationId(location);
                                                            if (location.trim()) {
                                                                setErrors((prevErrors) => {
                                                                    const updatedErrors = { ...prevErrors };
                                                                    delete updatedErrors.locationId;
                                                                    return updatedErrors;
                                                                });
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <label>Upload Image <span className="text-danger">*</span></label>
                                               
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept=".jpeg, .jpg, application/pdf"
                                                    onChange={handleLogoChange}
                                                />
                                            </div>
                                            <div className="col-md-4">

 <td>
                                                        {logoPreview ? (
                                                            /\.(pdf)$/i.test(logoPreview) ? (
                                                                <a
                                                                    href={logoPreview}
                                                                    download
                                                                    className="btn btn-sm btn-success"
                                                                >
                                                                    Download PDF
                                                                </a>
                                                            ) : (
                                                                /\.(jpg|jpeg|png)$/i.test(logoPreview) ? (
                                                                    <img
                                                                        src={logoPreview}
                                                                        alt="Image Preview"
                                                                        width="50"
                                                                        height="50"
                                                                        style={{ objectFit: "cover" }}
                                                                    />
                                                                ) : (
                                                                    <span>Unsupported file format</span>
                                                                )
                                                            )
                                                        ) : (
                                                            <span>No File Available</span>
                                                        )}
                                                    </td>



                                                {logoPreview && (
                                                    <div style={{ marginTop: -15 }}>
                                                        {image?.type === "application/pdf" ? (
                                                            <iframe
                                                                src={logoPreview}
                                                                title="PDF Preview"
                                                                width="100%"
                                                                height="100"
                                                                style={{ border: "1px solid #ccc" }}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={logoPreview}
                                                                alt="Preview"
                                                                style={{ width: 100, height: 100, objectFit: "cover" }}
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                           
                                        </div>
                                        <div className="d-flex justify-content-end gap-2 mt-4">
                                            <button className="btn btn-primary" onClick={updateMenuData}>Update</button>
                                            <button onClick={handleCancel} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <ToastContainer />
            </div>
        </div>

    );
};

export default PartyMenuList;